import type { Difficulty } from "@caiji-games/minesweeper-core";

export const DifficultyText: Record<Difficulty, string> = {
    easy: "🥉",
    medium: "🥈",
    hard: "🥇",
};
